import styled from "styled-components";

interface IVctTicketRow {
  toConfirm?: any;
}
export const VctTicketRow = styled.div<IVctTicketRow>`
  ${(props) => `
    border: ${props.toConfirm ? "solid 1px" : "none"};
    color: ${props.theme.colors.blackT73extTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 1rem;
  cursor: pointer;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  .customs-agent {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-left: 2.2rem;
    padding: 0;
    text-align: left;
  }

  .dispatcher-info {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-left: 2.2rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0;
    text-align: left;
  }

  .dispatcher-id {
    color: ${(props) => props.theme.colors.primaryBlue};
    font-weight: 600;
  }

  .volantes-num {
    color: ${(props) => props.theme.colors.gray};
  }

  p {
    margin: 0.2rem;
  }

  & > div {
    align-items: center;
    display: flex;
    justify-content: center;
    text-align: center;
  }

  .aux-div {
    flex-direction: column;
  }
`;
interface IStatusDiv {
  status?: string;
}

export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${color};
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0.6rem;
      }
  `;
  }}
`;
interface IPlateDiv {
  status?: string;
}
export const PlateDiv = styled.div<IPlateDiv>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    let display = "block";
    if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.blackTextBody;
      backgroundColor = "white";
      display = "inline";
    } else {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    }
    return `
      span {
        display: ${display};
        background-color: ${backgroundColor};
        color: ${color};
        font-size: ${status === "ok" ? "1.4rem" : "1.1rem"};
        font-weight: ${status === "ok" ? "500" : "600"};
        padding: 0.6rem;
    }`;
  }}
`;

export const PlateBar = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const PlateSection = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  &:hover .tooltip {
    align-items: center;
    display: flex;
    flex-direction: column;
    top: 2rem;
    width: 100%;
  }
`;

interface IPlateAmount {
  status?: string;
}
export const PlateAmount = styled.div<IPlateAmount>`
  ${(props) => {
    return `
      span {
        background-color: ${
          props.theme.colors.gray72 + props.theme.transparencies.p20
        };
        color: ${props.theme.colors.blackTextBody};
        font-size: 1.2rem;
        font-weight: 600;
        margin-left: 0.3rem;
        padding: 0.6rem;
        width: 1rem;
      }
  `;
  }}
`;

interface IDivColumStatus {
  status?: string;
}
export const DivColumStatus = styled.div<IDivColumStatus>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else if (status === "neutral") {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    } else if (status === "serving") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else {
      color = props.theme.colors.orangeText;
      backgroundColor =
        props.theme.colors.orangeText + props.theme.transparencies.p10;
    }
    return `
    .type-column-hermes {
      background-color: ${backgroundColor};
      color: ${color};
      font-size: 1.1rem;
      padding: 0.6rem;
    }`;
  }}

  align-items: center;
  display: flex;
  font-family: Montserrat;
  font-size: 1.1rem;
  height: 2.5rem;
  justify-content: center;
`;

export const DivFlexColum = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DivMarginLeft = styled.div`
  margin-left: 1.4rem;
`;

export const DivImgLoading = styled.div`
  .img-size {
    height: 4rem;
    width: 4rem;
  }
`;
